import {
  STD_CANVAS_CSS,
  SHEET_PRINT_CSS
} from "@/components/stone-technical-drawing/engine/print/stdCanvasStyles";

const FONT_LINKS = `
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Arsenal:wght@400;700&family=Chakra+Petch:wght@600&display=swap">
`;

const BUDGET_PRINT_CSS = `
  table { width: 100%; }
  body { -webkit-print-color-adjust: exact; }
  .tr-table { border: 1px solid #333; margin: 0px; }
  .bg-texts { font-weight: bold !important; background-color: #302b63 !important; border-radius: 3px; padding: 3px; padding-right: 6px; padding-left: 6px; color: #fff !important; }
  .font-head-title { font-size: 14pt; font-weight: bold; font-family: 'Arsenal', sans-serif; color: #333; }
  .font-head-subtitle { font-size: 12pt; font-family: 'Arsenal', sans-serif; color: #666; }
  .font-title { font-size: 20pt; font-weight: bold; font-family: 'Chakra Petch', sans-serif; color: #333; }
  @page { size: A4; margin: 0.5cm; }
  @media print { .bg-texts { background-color: #302b63 !important; } }
`;

const DELIVERY_NOTE_PRINT_CSS = `
  body { -webkit-print-color-adjust: exact; margin: 0px; padding:0px; width: 100%; display: flex; flex-direction: row; flex-wrap: nowrap; }
  .font-head-title { font-size: 14pt; font-weight: bold; font-family: 'Arsenal', sans-serif; color: #333; }
  .font-head-subtitle { font-size: 12pt; font-family: 'Arsenal', sans-serif; color: #666; }
  .font-title { font-size: 20pt; font-weight: bold; font-family: 'Chakra Petch', sans-serif; color: #333; }
  .page-unbreak { page-break-after: always; background: #333; width: 1100px; display: flex; flex-wrap: nowrap !important; }
  @page { size: landscape; margin: 0.5cm; display: flex; flex-wrap: nowrap; }
`;

const EXIT_NOTE_PRINT_CSS = `
  body { -webkit-print-color-adjust: exact; margin: 0; padding: 0; width: 100%; display: flex; flex-direction: row; flex-wrap: nowrap; font-family: Arial, sans-serif; }
  .font-head-title { font-size: 14pt; font-weight: bold; font-family: Arial, sans-serif; color: #333; }
  .font-head-subtitle { font-size: 10pt; font-family: Arial, sans-serif; color: #666; }
  .font-title { font-size: 20pt; font-weight: bold; font-family: Arial, sans-serif; color: #333; }
  .text-head-title { font-size: 9pt; font-weight: bold; color: #333; }
  .tr-table { border: 1px solid #333; margin: 0; }
  @page { size: landscape; margin: 0.5cm; }
`;

function notifyError(notify, message) {
  if (typeof notify === "function") {
    notify({
      type: "error",
      message,
      timeout: 5000
    });
  }
}

function shouldCloseImmediately(context = {}) {
  return Boolean(context.isDesktop || (context.vuetify && context.vuetify.breakpoint && context.vuetify.breakpoint.lgAndUp));
}

export function printElement({
  elementId,
  title,
  styles = "",
  fonts = "",
  width = 600,
  height = 600,
  wrapperId = "",
  delay = 200,
  notify,
  context = {}
}) {
  const printNode = document.getElementById(elementId);
  if (!printNode) {
    notifyError(notify, "Documento nao encontrado para impressao.");
    return false;
  }

  const printWindow = window.open("", "", `width=${width},height=${height}`);
  if (!printWindow) {
    notifyError(notify, "Nao foi possivel abrir a janela de impressao.");
    return false;
  }

  setTimeout(() => {
    printWindow.document.open();
    printWindow.document.write(`<html><head><title>${title}</title>`);
    printWindow.document.write('<meta charset="utf-8">');
    printWindow.document.write(fonts);
    printWindow.document.write("<style>");
    printWindow.document.write(styles);
    printWindow.document.write("</style>");
    printWindow.document.write("</head><body>");
    if (wrapperId) printWindow.document.write(`<div id="${wrapperId}">`);
    printWindow.document.write(printNode.innerHTML);
    if (wrapperId) printWindow.document.write("</div>");
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.focus();
    printWindow.onload = () => {
      printWindow.print();
      if (shouldCloseImmediately(context)) {
        printWindow.close();
      } else {
        printWindow.onafterprint = () => printWindow.close();
      }
    };
  }, delay);

  return true;
}

export function printBudget(options = {}) {
  return printElement({
    elementId: options.elementId || "print-html",
    title: options.title || "Proposta Orcamentaria",
    styles: BUDGET_PRINT_CSS,
    fonts: FONT_LINKS,
    width: options.width || 600,
    height: options.height || 600,
    wrapperId: options.wrapperId || "imprimir-conteudo",
    delay: options.delay || 200,
    notify: options.notify,
    context: options.context
  });
}

export function printDeliveryNote(options = {}) {
  return printElement({
    elementId: options.elementId || "print-note",
    title: options.title || "Nota de entrega",
    styles: DELIVERY_NOTE_PRINT_CSS,
    fonts: FONT_LINKS,
    width: options.width || 600,
    height: options.height || 600,
    delay: options.delay || 300,
    notify: options.notify,
    context: options.context
  });
}

export function printTechnicalDrawing(options = {}) {
  return printElement({
    elementId: options.elementId || "print-technical-drawing",
    title: options.title || "Desenho Tecnico",
    styles: `${STD_CANVAS_CSS}\n${SHEET_PRINT_CSS}`,
    width: options.width || 900,
    height: options.height || 700,
    delay: options.delay || 250,
    notify: options.notify,
    context: options.context
  });
}

export function printExitNote(options = {}) {
  return printElement({
    elementId: options.elementId || "print-exit-note",
    title: options.title || "Nota de saida",
    styles: EXIT_NOTE_PRINT_CSS,
    width: options.width || 800,
    height: options.height || 700,
    delay: options.delay || 200,
    notify: options.notify,
    context: options.context
  });
}

export const saleDocumentPrintCss = {
  budget: BUDGET_PRINT_CSS,
  deliveryNote: DELIVERY_NOTE_PRINT_CSS,
  technicalDrawing: `${STD_CANVAS_CSS}\n${SHEET_PRINT_CSS}`,
  exitNote: EXIT_NOTE_PRINT_CSS
};
